// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Person20 from './Person20.tsx';
import Person20Filled from './Person20Filled.tsx';
import Person20CircleFilled from './Person20CircleFilled.tsx';
import Person24 from './Person24.tsx';
import Person24Filled from './Person24Filled.tsx';
import Person24CircleFilled from './Person24CircleFilled.tsx';
import Person40 from './Person40.tsx';
import Person40Filled from './Person40Filled.tsx';
import Person48 from './Person48.tsx';
import Person48Filled from './Person48Filled.tsx';

type PersonProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Person20,
    Person20Filled,
    Person20CircleFilled,
    Person24,
    Person24Filled,
    Person24CircleFilled,
    Person40,
    Person40Filled,
    Person48,
    Person48Filled,
};

const Person: FC<PersonProps> = ({ variation, ...props }) => {
    const variationKey = `Person${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Person" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Person;
